import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { first } from "rxjs/operators";
import { UserViewModel } from "src/app/auth/models/user.viewmodel";
import { User } from "../../auth/models/user";
import { UserService } from "../../auth/user.service";
import { ConfirmDialogComponent } from "../../shared/confirm-dialog/confirm-dialog.component";
import { ToastService } from "../../shared/toast.service";

@Component({
  selector: "app-admin-users",
  templateUrl: "./admin-users.component.html",
  styleUrls: ["./admin-users.component.scss"],
  providers: [ToastService],
})
export class AdminUsersComponent implements OnInit, OnDestroy {
  selectedUser: User;
  userForm: FormGroup;

  firstGroup: User[] = new Array();
  secondGroup: User[] = new Array();

  users: User[] = [];

  constructor(
    private _fb: FormBuilder,
    private _userService: UserService,
    private _toaster: ToastService,
    private _router: Router,
    private _modalService: NgbModal
  ) {}

  destroy$ = new Subject();
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  ngOnInit() {
    if (this.users.length > 0) this.refreshUserList();

    this.sortUserArray(this.users);
    this.userForm = new FormGroup({
      FirstUsersGroupOverview: this._fb.array(this.firstGroup),
      SecondUsersGroupOverView: this._fb.array(this.secondGroup),
    });
    this.getAllUsers();
  }

  // sorting incoming data in order to split in two
  // sorting stays
  sortUserArray(_users: User[]) {
    _users.forEach((user, index) => {
      if (_users.length % 2 == 0)
        if (index < _users.length / 2) this.firstGroup.push(user);
        else this.secondGroup.push(user);
      else if (index <= Math.fround(_users.length / 2))
        this.firstGroup.push(user);
      else this.secondGroup.push(user);
    });
  }

  getAllUsers() {
    var result = this._userService.getAllUsers();
    result.pipe(first()).subscribe((res) => {
      this.users = res;
      this.sortUserArray(this.users);
      this.buildUserOverView();
    });
  }

  buildUserOverView() {
    this.userForm = new FormGroup({
      FirstUsersGroupOverview: this._fb.array(this.firstGroup),
      SecondUsersGroupOverView: this._fb.array(this.secondGroup),
    });
  }

  onDeleteUser(user) {
    const modalRef = this._modalService.open(ConfirmDialogComponent);
    modalRef.componentInstance.message = $localize`:@@admin.user.confirmdeleteuser:Are you sure you want to delete ${user.firstName}?`;
    modalRef.componentInstance.confirmBtnTxt = "Delete";
    modalRef.componentInstance.confirmBtnClass = "btn btn-danger";
    modalRef.componentInstance.cancelBtnClass = "btn btn-primary-no-bg";
    modalRef.componentInstance.decision
      .pipe(first())
      .subscribe((decision: boolean) => {
        if (decision) this.deleteUser(user);
      });
  }

  deleteUser(user: UserViewModel) {
    this._userService
      .deleteUser(user)
      .pipe(first())
      .subscribe((response) => {
        // onder voorbehoud
        var message = this.ngOnInit();
        this._toaster.showSuccesToast(
          $localize`:@@admin.user.deleted:user ${user.firstName}`,
          $localize`:@@admin.user.deleted2:with email ${user.email} has been deleted`
        );
      });
  }

  refreshUserList() {
    this.firstGroup = [];
    this.secondGroup = [];
    this.users = [];
  }

  editUser(user: User) {
    this.selectedUser = user;
    var editUserModal = document.getElementById("editUserModal");
    editUserModal.classList.add("show");
    editUserModal.style.display = "block";
  }

  createUser() {
    var createUserModal = document.getElementById("addUserModal");
    var modalback = document.getElementsByClassName(
      "modal-backdrop"
    )[0] as HTMLElement;

    createUserModal.classList.add("show");
    createUserModal.style.display = "block";
  }

  receiveUserAddedFromChild(data: any) {
    this.ngOnInit();
  }

  receiveUserEditedFromChild(data: any) {
    this.ngOnInit();
  }

  onUnlockUser(userId: string) {
    this.ngOnInit();
  }
}
